import { InjectionToken } from '@angular/core';

export const DIALOG_TOKEN = new InjectionToken<string>('confirmationDialog');
